import { render, staticRenderFns } from "./ProductFormTopMobile.vue?vue&type=template&id=57264fae&scoped=true&lang=pug&"
import script from "./ProductFormTopMobile.vue?vue&type=script&lang=js&"
export * from "./ProductFormTopMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormTopMobile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductFormTopMobile.vue?vue&type=style&index=1&id=57264fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57264fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57264fae')) {
      api.createRecord('57264fae', component.options)
    } else {
      api.reload('57264fae', component.options)
    }
    module.hot.accept("./ProductFormTopMobile.vue?vue&type=template&id=57264fae&scoped=true&lang=pug&", function () {
      api.rerender('57264fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductFormTopMobile.vue"
export default component.exports